import { transformErrorResponse } from "../../transformErrorResponse"
import { FilesDocDTO, MiFibraENTITYDB } from "sigo-entities"
import { AtcApiBuilder } from "."

export const PERU_9112_MiFibraOrder = (build: AtcApiBuilder) => {
    return {
        getByIdMiFibraOrders: build.query<MiFibraENTITYDB[], string>({
            query: (userId) => `procesos/peru_9112_mifibraorder/${userId}`,
            providesTags: (result, error, userId) =>
                result
                    ? [
                        // tag individual por cada orden
                        ...result.map((order) => ({
                            type: 'MiFibraOrders' as const,
                            id: order._id,
                        })),
                        // y un tag general de la lista de ese usuario
                        { type: 'MiFibraOrders' as const, id: `USER-${userId}` },
                    ]
                    : [{ type: 'MiFibraOrders' as const, id: `USER-${userId}` }],
            transformErrorResponse
        }),
        getTransitMiFibraOrders: build.query<{ transito: number }, { id_recurso: string, codigo: string }>({
            query: ({ id_recurso, codigo }) => `procesos/peru_9112_mifibraorder/calculate-transit/${id_recurso}/${codigo}`,
            transformErrorResponse
        }),
        addInventoryMiFibraOrders: build.mutation<MiFibraENTITYDB, { id: string, body: { ID_StockPersonal: number, cantidad: number } }>({
            query: ({ body, id }) => ({
                url: `procesos/peru_9112_mifibraorder/add-inventory/${id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'MiFibraOrders' as const, id },
            ],
            transformErrorResponse
        }),
        deleteInventoryMiFibraOrders: build.mutation<MiFibraENTITYDB, { id: string, codigo: number, serie: string }>({
            query: ({ id, codigo, serie }) => ({
                url: `procesos/peru_9112_mifibraorder/delete-inventory/${id}/${codigo}?serie=${serie}`,
                method: "PUT",
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'MiFibraOrders' as const, id },
            ],
            transformErrorResponse
        }),
        finalizeMiFibraOrders: build.mutation<MiFibraENTITYDB, { id: string }>({
            query: ({ id }) => ({
                url: `procesos/peru_9112_mifibraorder/finalize/${id}`,
                method: "PUT"
            }),
            invalidatesTags: (result, error, { id }) => [
                // invalida la orden puntual
                { type: 'MiFibraOrders' as const, id },
                // y también la lista del usuario (para que se refresque)
                // { type: 'WINOrders' as const, id: `USER-${userId}` },
            ],
            transformErrorResponse
        }),
        uploadPhotosMiFibraOrders: build.mutation<MiFibraENTITYDB, { id: string, boletin: FilesDocDTO }>({
            query: ({ boletin, id }) => ({
                url: `procesos/peru_9112_mifibraorder/upload-files/${id}`,
                method: "PUT",
                body: { boletin },
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'MiFibraOrders' as const, id },
            ],
            transformErrorResponse
        }),
    }
}